import Router from "@/router/index.js";

const user = JSON.parse(localStorage.getItem("user"));

const state = user ? { user } : { user: null };

const actions = {
  async login({ commit, dispatch }, payload) {
    const user = payload.user;
    const headers = payload.headers;
    const roles = ['superadmin', 'space_owner'];

    if (roles.includes(user.role)) {
      localStorage.setItem("token", headers["x-token-id"]);
      localStorage.setItem("refresh-token", headers["x-token-refresh"]);
      localStorage.setItem("user", JSON.stringify(user));

      commit("loginSuccess", user);

      if (user.spaces && user.spaces.length) {
        const spaceId = user.spaces[0];

        const space = await dispatch('space/getSpace', spaceId, { root: true });

        if (space.status === 'approved') {
          location.href = '/bookings';
        } else {
          location.href = "/welcome";
        }
      } else {
        location.href = "/welcome";
      }
    } else {
      location.href = "/login";
    }
  },

  logout({ commit }) {
    commit("logout");
  },

  update({ commit }, payload) {
    localStorage.setItem("user", JSON.stringify(payload.user));

    commit("updateSuccess", payload.user);
  }
};

const mutations = {
  loginSuccess(state, user) {
    state.user = user;
  },

  changeAdminData(state, user) {
    state.user = user;
  },

  loginFailure(state) {
    state.user = null;
  },

  logout(state) {
    localStorage.removeItem("token");
    localStorage.removeItem("refresh-token");
    localStorage.removeItem("user");

    Router.go("/login");

    state.user = null;
  },

  updateSuccess(state, user) {
    state.user = user;
  }
};

const getters = {
  userEmail: state => state.user.email,
  user: state => state.user,
  spaces: state => state.user.spaces,
  spaceId: state => (state.user.spaces) ? state.user.spaces[0] : null
};

export const currentUser = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/currentUser.js